// Superset of _listingCardMapper's card output for DPP-only UI (not rendered as a card) and
// computations like estprice.js comparables. Extends mapCardListing rather than duplicating it, so
// card-display derivations (status, isNew, formatMlsInfo, etc.) stay in one place. Only adds fields
// that actually exist on CardListing (see www/api/carousel/types/card-listing.ts) — the upstream
// carousel service (searchNearbyCarousel_v1) does not return yearBuilt, garage, hoafee,
// publicRemarks, virtualLink, or categorizedPhotos, so those can't be sourced from this data.

import { mapCardListing, mapCardsResult } from './_listingCardMapper.js';

export { mapCardListing, mapCardsResult };

// Pass `baseCard` when the caller already has a mapCardListing result for this listing (e.g. cards
// mapped earlier in the same request) to skip re-deriving it. `listing` (raw CardListing) is needed
// for the MLS/agent attribution fields below — if it's not available (only a mapped card is), those
// are skipped and only pricePerArea (derivable from the base card alone) is added.
export function mapListingDetail(listing, compliance, cdnUrl, baseCard) {
    const base = baseCard || mapCardListing(listing, compliance, cdnUrl);
    const detail = {
        ...base,
        pricePerArea: base.area ? base.price / base.area : 0,
    };
    if (!listing) return detail;

    return {
        ...detail,
        permitAvm: !!listing.permitAvm,
        agentListFullName: listing.agentListFullName || '',
        officeListName: listing.officeListName || '',
        officeListPhone: listing.officeListPhone || null,
        mlsNumber: listing.mlsNumber || '',
        listDate: listing.listDate || null,
        createdAt: listing.createdAt || null,
        priceChanged: listing.priceChanged ?? null,
    };
}

export function mapListingsDetail(cardsResult, cdnUrl) {
    return (cardsResult?.listings || []).map((item) => mapListingDetail(item, cardsResult.compliance?.[item.mls?.id] || null, cdnUrl));
}
